import { client, DEFAULT_HEADERS } from "./defaultClient";
import { UserQuestion } from "./generated";

export const getUserQuestionByAnswererId = async (
    answererId: string
): Promise<UserQuestion[]> =>
    await client.getUserQuestionsAnswererId({ answererId }, { mode: "cors" });

export const getUserQuestionById = async (id: string): Promise<UserQuestion> =>
    await client.getUserQuestionId({ id }, { mode: "cors" });

export const createUserQuestion = async (
    answererId: string,
    title: string,
    csrfToken: string
): Promise<UserQuestion> => {
    return await client.postUserQuestion(
        {
            postUserQuestionRequest: {
                answererId,
                title,
            },
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const updateUserQuestion = async (
    id: string,
    title: string,
    csrfToken: string
): Promise<UserQuestion> => {
    return await client.patchUserQuestionId(
        {
            id,
            patchUserQuestionIdRequest: {
                title,
            },
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const deleteUserQuestion = async (
    id: string,
    csrfToken: string
): Promise<void> => {
    return await client.deleteUserQuestionId(
        {
            id,
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};
